import notion from "../images/notion.svg";
import slack from "../images/slack.svg";
import fast from "../images/fast.svg";
import infromed from "../images/infromed.svg";
import affordable from "../images/affordable.svg";
import blinking from "../images/blinking.svg";

export const subBanner = [
  {
    icon: notion,
    name: "Notion",
  },
  {
    icon: slack,
    name: "Slack",
  },
  {
    icon: notion,
    name: "Notion",
  },
  {
    icon: slack,
    name: "Slack",
  },
  {
    icon: notion,
    name: "Notion",
  },
];

export const features = [
  {
    icon: fast,
    title: "Fast",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    link: "",
  },
  {
    icon: affordable,
    title: "Affordable",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    link: "",
  },
  {
    icon: infromed,
    title: "Informed",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    link: "",
  },
];
export const subDashboard = [
  {
    icon: fast,
    title: "Lighting Fast",
    text: "No lags, no time consuming process. Logging in in any app is as easy as a snap. Beacuase you care for you and saving your valuable time.",
    link: "",
  },
  {
    icon: blinking,
    title: "Easy as blinking",
    text: "The UI is so easy that you don’t have to look twice. Its that obivious! ",
    link: "",
  },
  {
    icon: infromed,
    title: "Advanced analytics",
    text: "An all-in-one platform that helps you find and manage all the data, plus the analytics that helps to make informed decisions",
    link: "",
  },
];
